/// <reference path="./moment-locales.d.ts" />
import type { SupportedLocale } from "./locales";

// moment only registers a locale through its dist build (https://stackoverflow.com/a/71966958); English is built in.
const loaders = {
  ar: () => import("moment/dist/locale/ar"),
  bg: () => import("moment/dist/locale/bg"),
  cs: () => import("moment/dist/locale/cs"),
  de: () => import("moment/dist/locale/de"),
  en: () => Promise.resolve(),
  es: () => import("moment/dist/locale/es"),
  fr: () => import("moment/dist/locale/fr"),
  hu: () => import("moment/dist/locale/hu"),
  it: () => import("moment/dist/locale/it"),
  nl: () => import("moment/dist/locale/nl"),
  pl: () => import("moment/dist/locale/pl"),
  pt: () => import("moment/dist/locale/pt"),
  ro: () => import("moment/dist/locale/ro"),
  ru: () => import("moment/dist/locale/ru"),
  sk: () => import("moment/dist/locale/sk"),
  tr: () => import("moment/dist/locale/tr"),
  uk: () => import("moment/dist/locale/uk"),
} satisfies Record<SupportedLocale, () => Promise<unknown>>;

/** Registers moment's locale data, so `moment.locale(code)` switches instead of staying on the current locale. */
export async function loadMomentLocale(code: SupportedLocale): Promise<void> {
  await loaders[code]();
}
